import { render, staticRenderFns } from "./SideNavbar.vue?vue&type=template&id=eb3f8f06&scoped=true"
import script from "./SideNavbar.vue?vue&type=script&lang=js"
export * from "./SideNavbar.vue?vue&type=script&lang=js"
import style0 from "./SideNavbar.vue?vue&type=style&index=0&id=eb3f8f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3f8f06",
  null
  
)

export default component.exports